// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'http://localhost:55171/api/1.0',
  // apiUrl: 'https://rntdesback.confecamaras.co/api/1.0',
  // apiUrl: 'https://rnt3.confecamaras.co/api/1.0',
  // apiUrl: 'http://172.40.10.32:8182/api/1.0',
  // apiUrl: 'http://172.40.10.32:8184/api/1.0',
  // apiUrl: 'http://172.40.10.32:8185/api/1.0',
  // apiUrl: 'http://devel.olsoftware.com:8184/api/1.0',
  keyReCaptcha: '6LdaDoQUAAAAAJIHtQFY8mZ60rRWd2wNyy6xjMa2',
  amazonImage: 'https://rnt-desarrollo.s3.amazonaws.com',
  ksaPassPublico: 'ukhliS]KfXczjhjA7uldcrqy62_-uXMn{t];v8u&61j',
  idGoogleAnalytic: 'UA-132311128-1',
  encryptionKey:'BAJibaOABNjhnioUA8ujaiKNALIOua89UI__¡__-_$$**:_MXAP',
  version: 'DEV',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
